export default __webpack_public_path__ + "static/media/qr-code.999fe9c3.gif";